import * as React from "react";
import { IFetchOrderProductsResponse } from "./fetchOrderProducts";

export const ProductsContext =
  // eslint-disable-next-line unicorn/no-null
  React.createContext<IFetchOrderProductsResponse | null>(null);

export function useProducts() {
  const value = React.useContext(ProductsContext);

  if (value === null) {
    throw new Error("`Missing ProductsContext` in tree.");
  }

  return value;
}

export function useOptionalProducts() {
  return React.useContext(ProductsContext);
}
